import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useFullFormPageStore } from 'store/pages/utility/full-form/pageStore';
import { DynamicFormStyled, EmployeeFormWrapperStyled } from './styles';
import { EMPLOYEE_PROFILE_FORM_TEST_ID, EMPLOYEE_PROFILE_TAB_TEST_ID } from '../../constants';

const EmployeeProfileTab: React.FC = observer(() => {
  const {
    employeeProfileTab: { dynamicJSONFormDelegate, fetchForm },
    subscriberExists,
    isInitialDataLoading,
  } = useFullFormPageStore();

  const formExists = dynamicJSONFormDelegate.formController;

  useEffect(() => {
    if (!isInitialDataLoading && !formExists) {
      void fetchForm();
    }
  }, [isInitialDataLoading, formExists]);

  return (
    <EmployeeFormWrapperStyled data-test-id={EMPLOYEE_PROFILE_TAB_TEST_ID}>
      <DynamicFormStyled
        formDelegate={dynamicJSONFormDelegate}
        completeButtonText={subscriberExists ? 'Update' : 'Save'}
        data-test-id={EMPLOYEE_PROFILE_FORM_TEST_ID}
        noBorderOnError
      />
    </EmployeeFormWrapperStyled>
  );
});

export default EmployeeProfileTab;
